import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GetClassroomByTeacher, GetClassroomByTeacherResponse } from '@edtech-ui/core/models/Classroom/get-classroomByTeacher';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { ClassroomPostDialogBoxComponent } from '@edtech-ui/dashboard/teacher/classroom/classroom-post-dialog-box/classroom-post-dialog-box.component';
import { Roles } from '@edtech-ui/constants/roles.enum';

@Component({
	selector: 'app-student-classrooms',
	standalone: true,
	imports: [SharedModule],
	templateUrl: './student-classrooms.component.html',
	styleUrl: './student-classrooms.component.scss'
})
export class StudentClassroomsComponent implements OnInit, OnDestroy {
	searchQuery = '';
	_classroom: GetClassroomByTeacher[] = [];
	filteredClassrooms: GetClassroomByTeacher[] = [];
	isLoading: boolean = false;
	subscription = new Subscription();

	constructor(
		private router: Router,
		private dialog: MatDialog,
		private _toastr: ToastrService,
		private _classroomService: ClassroomManagementService
	) { }

	ngOnInit(): void {
		this.getClassroom();
	}

	getClassroom(page: number = 1, pageSize: number = 10) {
		this.isLoading = true;
		this.subscription.add(
			this._classroomService.getStudentClassrooms(page, pageSize).subscribe({
				next: (response: GetClassroomByTeacherResponse) => {
					if (response.Success) {
						this._classroom = response.Data.classrooms.map(classroom => ({
							...classroom,
							id: classroom.id || 0,
							cover_image_url: classroom.cover_image_url || ''
						}));
						this.filteredClassrooms = [...this._classroom];
					} else {
						this._toastr.error(response.Message || 'Failed to fetch classes.');
					}
					this.isLoading = false;
				},
				error: (err) => {
					this._toastr.error('Failed to fetch classes due to a network error.');
					this.isLoading = false;
				}
			})
		);
	}

	goToClassroomPage(classroomId: number) {
		this.router.navigate(['/student-dashboard/classroom-detail-page', classroomId, 'overview']);
	}

	openJoinDialogBox() {
		const roleId = localStorage.getItem('role_id');
		const userRole = roleId ? parseInt(roleId) as Roles : Roles.STUDENT;
		this.dialog.open(ClassroomPostDialogBoxComponent, {
			data: { userRole }
		}).afterClosed().subscribe(result => {
			if (result) {
				this.getClassroom();
			}
		});
	}

	onSearchQueryChange(query: string): void {
		const q = query.trim().toLowerCase();
		if (!q) {
			this._classroom = [...this.filteredClassrooms];
			return;
		}
		this._classroom = this.filteredClassrooms.filter(c =>
			c.name?.toLowerCase().includes(q) || c.teacher_name?.toLowerCase().includes(q));
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}